export enum ScreenSizeEnum {
  Mobile = 'mobile',
  Tablet = 'tablet',
  Desktop = 'desktop',
  None = 'none',
}
